<div *ngIf="breadcrumbs.length > 1" class="breadcrumb breadcrumb-navigation mb-1">
  <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last="last">
    <li class="breadcrumb-item" [class.active]="last" *ngIf="!last && breadcrumb.data.title">
      <a *ngIf="!last" [routerLink]="breadcrumb.url">
        {{
          breadcrumb.data.resolvedInfo
            ? breadcrumb.data.resolvedInfo.breadcrumbPath
            : (breadcrumb.data.title | translate | normalCase)
        }}
      </a>
    </li>
  </ng-template>
</div>
<ng-container *ngIf="breadcrumbs.length > 0">
  <h2 *ngIf="breadcrumbs[breadcrumbs.length - 1]">
    {{
      breadcrumbs[breadcrumbs.length - 1].data.resolvedInfo
        ? breadcrumbs[breadcrumbs.length - 1].data.resolvedInfo.breadcrumbPath
        : (breadcrumbs[breadcrumbs.length - 1].data.title | translate)
    }}
  </h2>
</ng-container>
